import { formatAssetName } from 'utils/strings'

/** User-facing labels for LP **Lead** asset fields (Icons how-to / BLIK `lead/version_2`). */
export const LP_LEAD_COPY_FIELD_LABELS = {
  name: 'Name',
  defaultDescription: 'First description line',
  descriptionForEuro: 'First description line For Euro',
  bannerTitleAccent: 'Accent text',
  additionalText: 'Additional description'
} as const

export function isLeadLandingPageAssetType(assetType?: string | null): boolean {
  return formatAssetName(assetType ?? '') === 'lead'
}
